import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {User} from "../../../../models/user";
import {NgForm, NgModel} from "@angular/forms";
import PlaceResult = google.maps.places.PlaceResult;

@Component({
    selector: 'epds-add-or-edit-agency-contact',
    templateUrl: './add-or-edit-agency-contact.component.html',
    styleUrl: './add-or-edit-agency-contact.component.scss',
    standalone: false
})
export class AddOrEditAgencyContactComponent implements OnInit {
  selectedUser!: User;

  @Input() user!: User;
  @Input() addOrEditInd: 'A'|'E'|null = 'E';
  @Input() showAddress = false;
  @Input() addressMode = false;
  @Input() saving = false;

  @Output() btnClicked = new EventEmitter<any>();


  ngOnInit() {
    if (this.user) {
      this.selectedUser = {...this.user};
    }
  }

  onSubmit() {
    console.debug(this.selectedUser);
  }

  canSave(registerForm: NgForm) {
    let canBeSaved = registerForm.valid && registerForm.dirty;

    return canBeSaved;
  }

  checkPhone(control:NgModel) {
    const phone = control.control.value;

    if (phone) {
      const digits = phone.replace(/\D/g, "");

      if (digits?.length < 10) {
        control.control.setErrors({error: "Must be at least 10 digits"})
      }
    }

  }

  placeChanged(place: PlaceResult) {
    let streetAddr = place.formatted_address?.split(",")[0]
    if (place.name !== streetAddr) {
      streetAddr = place.name + "," + streetAddr;
    }
    this.selectedUser.address1 = streetAddr;

    place.address_components?.forEach(component => {
      const types = component.types;
      if (types.includes('locality')) {
        this.selectedUser.city = component.long_name;
      } else if (types.includes('administrative_area_level_1')) {
        this.selectedUser.state = component.long_name;
      } else if (types.includes('country')) {
        this.selectedUser.country = component.long_name;
      } else if (types.includes('postal_code')) {
        this.selectedUser.zip_Code = component.long_name;
      }
    });
  }
}
